
export const TAC_TEMPLATE_TYPES = {
    RESTAURANT: "Restaurant",
    SPA: "Spa",
    ACTIVITY: "Activity",
};

export function isTacActivity(serviceProfileTemplateType) {
    return serviceProfileTemplateType === TAC_TEMPLATE_TYPES.ACTIVITY;
}
